import { Component, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { NgSelectComponent } from '@ng-select/ng-select';
import { AuthenticationService } from 'src/app/authentication.service';
// import { PetRegistrationService } from 'src/app/pet/pet-layout/service/pet-registration.service';
import { ProfileService } from 'src/app/portal/service/profile.service';
import { session } from 'src/environments/environment.session';
import Swal from 'sweetalert2';
import { MainService } from '../../services/main.service';
import { MainService as portal_mainService } from '../../../portal/service/main.service';
import { CaseService } from '../../services/case.service';

@Component({
  selector: '[app-case-header]',
  templateUrl: './case-header.component.html',
  styleUrls: ['./case-header.component.css']
})
export class CaseHeaderComponent {
  b_acct_id: any;

  constructor(private caseservice: CaseService, private router: Router, public profileService: ProfileService, private sanitizer: DomSanitizer, public portal_main: portal_mainService,

    public mainService: MainService, public auth: AuthenticationService) { }

  erpUser: any;
  hidden = true;
  isDropdownOpen = false;
  selectedAction: any

  // home() {
  //   this.router.navigate(['/icms/icms-index'])
  // }
  accInfo = {
    account_name: 'ABC'
  }

  noti_count = 0;
  noti_data: any;
  message_count: any;
  placeholderText: any

  action = [
    { id: 1, name: 'Profile', route: "profile" },
    { id: 2, name: 'Logout', route: "login" },
  ];
  @ViewChild('ngSelectElement') ngSelectElement!: NgSelectComponent;

  async ngOnInit() {

    console.log(this.auth.allLanguage, 'allLanguage')
    this.erpUser = JSON.parse(atob(session.erpUser))
    this.b_acct_id = this.erpUser.b_acct_id;
    console.log(this.erpUser)
    // await this.get_notification_log()
    let dd = [];
    dd = this.erpUser.role_cd
    if (dd.includes("AA")) {
      this.hidden = false;
    } else {
      this.hidden = true
    }
    await this.portal_main.getUserImage(this.erpUser['user_id']);
    await this.portal_main.getAccImage(this.erpUser['b_acct_id']);
    await this.portal_main.getAccountInfo(this.erpUser['b_acct_id']);
    await this.portal_main.getHeaderInfo(this.erpUser['b_acct_id']);
    await this.changeLanguage();
    let data = await this.portal_main.getNotification(this.erpUser['b_acct_id'], this.erpUser['user_id']);
    // this.noti_count = data.noti_count;
    this.noti_data = data.noti_data;
    let message = await this.portal_main.getMessageCount(this.erpUser['b_acct_id'], this.erpUser['user_id']);
    this.message_count = message && message.length ? message.length : 0;
    this.placeholderText = this.erpUser['party_name']
  }


  goToIndex(data: any) {
    this.portal_main.icms_notification_data = data;
    this.router.navigate(['/notification']);
    console.log("Go to notification ")
  }

  changeLanguage() {
    console.log("laungage Change");
    this.portal_main.language_cd = this.auth.language_cd
    this.portal_main.allLanguage = this.auth.allLanguage
  }
  toggleSelect() {
    const checkClss = document.getElementById('ss')
    if (this.isDropdownOpen) {
      this.ngSelectElement.close();
    } else {
      this.ngSelectElement.open();
    }
    this.isDropdownOpen = !this.isDropdownOpen;
  }
  onSelectionChange2() {
    const selectedVal = this.selectedAction.route
    this.router.navigate([selectedVal]);
  }
  async logOut() {
    sessionStorage.removeItem("1001");
    sessionStorage.removeItem("1000"); sessionStorage.removeItem("1005");
    session.erpUser = undefined
    this.router.navigate(['/login']);
  }
  go_to_task() {
    console.log("ia m in")
    this.router.navigate(['/task']);

  }
  // statment: any = []
  // async get_notification_log() {
  //   let send: any = []
  //   let case_role = ['CASE_EMP', 'CASE_ADMIN'];
  //   case_role.map((x: any, i) => {
  //     this.erpUser['role_cd'].map((y: any, j: any) => {
  //       if (x == y) {
  //         send.push(x)
  //       }
  //     })
  //   })

  //   console.log(send)
  //   if (send.length <= 0) {
  //     send.push('')
  //   }
  //   let obj: any = {};
  //   obj['b_acct_id'] = this.b_acct_id;
  //   obj['role_cd'] = send;
  //   obj['module_cd'] = 'CASE'
  //   let resp = await this.caseservice.notification((obj));
  //   console.log(resp);
  //   if (resp['error'] == false) {
  //     this.statment = resp['data'];
  //     this.statment.map((x: any) => {
  //       if (x.is_seen == 0) {
  //         this.noti_count++;
  //       }
  //     })

  //   } else {
  //     Swal.fire('error', 'server side error', 'error');
  //     return
  //   }
  // }

  async open_noification() {
    this.router.navigate(['/case/notification']);
  }

  go__task() {
    this.router.navigate(['/task']);

  }


}
